// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

// jQuery is exposed on window because several legacy plugins below (and a
// number of inline <script> blocks still living in app/views/*.erb, not yet
// converted to Stimulus controllers) expect a global `$`/`jQuery`. Done via
// its own module (see jquery_global.js for why) rather than an inline
// `import jquery from "jquery"; window.jQuery = jquery` here -- that
// ordering let bootstrap-toggle below run (and throw, since it needs
// window.jQuery at its own top level) before this file's own assignment
// statement ever got a chance to execute.
import "./jquery_global"

// Bootstrap 5 ships its own JS (no jQuery dependency) for
// modals/dropdowns/etc.
import * as bootstrap from "bootstrap"
window.bootstrap = bootstrap

// jQuery plugins used across the app views (DataTables, datepicker, toggle
// switches, tag input, image lightbox, markdown editor). Each attaches
// itself to jQuery.fn as a side effect of being imported.
import "bootstrap-datepicker"
import "bootstrap-toggle"
import "datatables.net-bs5"
import "@fancyapps/fancybox"
import "./vendor/tagmanager.js"

// Flash messages (see flash_message_controller.js) render as toastr
// notifications rather than inline alert banners.
import toastr from "toastr"
window.toastr = toastr
toastr.options = {
  progressBar: true,
  positionClass: "toast-top-center",
  preventDuplicates: true,
  timeOut: 5000,
}

// PDF generation used by customer_orders/receipt_pdf and vendor_profiles
import jsPDF from "jspdf"
window.jsPDF = jsPDF
import html2canvas from "html2canvas"
window.html2canvas = html2canvas
